(function() {
  // ===== Transparent Header (Homepage Only) =====
  const ptHeader = document.querySelector('.header-wrapper');
  if (ptHeader && document.body.classList.contains('transparent-header')) {
    const onScroll = () => {
      ptHeader.classList.toggle('is-solid', window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ===== Scroll Animation =====
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.pt-animate').forEach(function(el) {
      el.classList.add('pt-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('pt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px 0px 0px' });

  var firstSection = document.querySelector('.main-content > .shopify-section:first-child');

  var targets = document.querySelectorAll([
    '.rich-text',
    '.multicolumn-card',
    '.footer-block-disabled'
  ].join(','));

  targets.forEach(function(el) {
    if (el.closest('slideshow-component')) return;
    if (firstSection && firstSection.contains(el)) return;

    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('pt-animate', 'pt-visible');
      return;
    }

    requestAnimationFrame(function() {
      el.classList.add('pt-animate');
      observer.observe(el);
    });
  });
})();